(() => {
  const selector = '[data-rec-intent-router]';
  const storageKey = 'recIntentLane';
  const routes = {
    apparel: { badge: 'WEAR IT', title: 'GO STRAIGHT TO REC APPAREL', copy: 'Graphic tees, REC Originals, After Dark, workwear, faith, seasonal drops and more. Start with the full apparel lane, then narrow it down.', label: 'SHOP APPAREL', href: '/collections/apparel', extras: [['NEW DROPS','/collections/new-drops'],['REC ORIGINALS','/collections/rec-originals'],['REC AFTER DARK','/collections/rec-after-dark']] },
    fast: { badge: 'NEED IT NOW', title: 'READY TO SHIP', copy: 'Already-made pieces with no production wait. Shop everything ready now—or jump straight to the category you need.', label: 'SHOP READY TO SHIP', href: '/collections/ready-to-ship-items', extras: [['APPAREL','/collections/ready-to-ship-apparel'],['BADGE REELS','/collections/ready-to-ship-badge-reels'],['TUMBLERS','/collections/ready-to-ship-tumblers'],['DTF TRANSFERS','/collections/ready-to-ship-dtf-transfers']] },
    dtf: { badge: 'PRESS IT', title: 'BUILD YOUR DTF GANG SHEET', copy: 'Upload your art, build your sheet, and order ready-to-press transfers. Need the press settings first? We’ve got those too.', label: 'BUILD A GANG SHEET', href: '/products/build-your-own-gang-sheet', extras: [['DTF INSTRUCTIONS','/pages/dtf-transfer-instructions'],['READY-TO-PRESS DTF','/collections/ready-to-press']] },
    tumblers: { badge: 'DRINK IT', title: 'SHOP REC TUMBLERS', copy: 'Ask REC about custom engraving, shop sublimation for full-color artwork, or browse the whole drinkware lineup.', label: 'SHOP TUMBLERS', href: '/collections/tumblers', extras: [['CUSTOM ENGRAVING INQUIRY','/pages/contact-us'],['SUBLIMATION','/collections/sublimation-tumblers'],['NFL GRAFFITI','/collections/nfl-graffiti-tumblers']] },
   
    laser: {
      badge: 'MAKE IT PERSONAL',
      title: 'LASER ENGRAVING & PERSONALIZED GIFTS',
      copy: 'Personalized wood signs, engraved coasters, ornaments, and custom gifts.',
      label: 'SHOP LASER ENGRAVING',
      href: '/collections/rec-laser-engraving',
      extras: [
        ['CUSTOM ORDERS', '/pages/contact-us'],
        ['ENGRAVED TUMBLERS', '/collections/engraved-tumblers']
      ]
    },

    custom: { badge: 'BUILD IT', title: 'MAKE SOMETHING THAT DOESN’T EXIST YET.', copy: 'Shirts, tumblers, engraving, DTF—or something completely your own. Tell REC what you’re trying to make and start the conversation.', label: 'START A CUSTOM ORDER', href: '/pages/contact-us', extras: [['LASER ENGRAVING','/collections/rec-laser-engraving'],['SEE ALL COLLECTIONS','/pages/shirt-collections'],['ABOUT REC','/pages/about-rustic-edge-customs']] }
  };

  const saveLane = (key) => { try { window.sessionStorage.setItem(storageKey, key); } catch (_) {} };
  const getLane = () => { try { return window.sessionStorage.getItem(storageKey); } catch (_) { return null; } };

  const renderRoute = (root, key, save = true) => {
    const route = routes[key];
    if (!route) return;
    root.classList.toggle('is-fast-route', key === 'fast');
    root.querySelectorAll('[data-rec-intent]').forEach((button) => {
      const active = button.dataset.recIntent === key;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    const badge = root.querySelector('[data-rec-router-badge]');
    const title = root.querySelector('[data-rec-router-title]');
    const copy = root.querySelector('[data-rec-router-copy]');
    const primary = root.querySelector('[data-rec-router-primary]');
    const extras = root.querySelector('[data-rec-router-extras]');
    if (badge) badge.textContent = route.badge;
    if (title) title.textContent = route.title;
    if (copy) copy.textContent = route.copy;
    if (primary) {
      primary.href = route.href;
      primary.replaceChildren(document.createTextNode(`${route.label} `));
      const arrow = document.createElement('span');
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '→';
      primary.append(arrow);
    }
    if (extras) {
      extras.replaceChildren(...route.extras.map(([label, href]) => {
        const link = document.createElement('a');
        link.href = href;
        link.textContent = label;
        return link;
      }));
    }
    if (save) saveLane(key);
  };

  const init = (root) => {
    if (root.dataset.recRouterInit === 'true') return;
    root.dataset.recRouterInit = 'true';
    root.querySelectorAll('[data-rec-intent]').forEach((button) => {
      button.addEventListener('click', () => renderRoute(root, button.dataset.recIntent));
    });
    const remembered = getLane();
    if (remembered && routes[remembered]) renderRoute(root, remembered, false);
  };

  const mount = () => {
    const root = document.querySelector(selector);
    if (!root) return;
    const main = document.querySelector('#MainContent');
    const trust = document.querySelector('#MainContent [id$="__custom_liquid_rec_trust"], #MainContent [id*="custom_liquid_rec_trust"]');
    if (trust && root.previousElementSibling !== trust) {
      trust.insertAdjacentElement('afterend', root);
    } else if (!trust && main && root.parentElement !== main) {
      const first = main.firstElementChild;
      if (first) first.insertAdjacentElement('afterend', root);
      else main.append(root);
    }
    root.hidden = false;
    init(root);
  };

  const start = () => {
    mount();
    window.setTimeout(mount, 700);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', mount);
})();